module.exports = __webpack_public_path__ + "img/modal-segment-destroy.54836973.svg";